export default __webpack_public_path__ + "static/media/J730_SOV.5f3f90d7.pdf";